export function getItemProperties(item) {
	switch (item.type) {
		case 'area':
			return {
				content:
					'Esta camada apresenta as áreas medidas e salvas no aplicativo. Apenas você e pessoas autorizadas podem ver esses dados.',
				font: 'Usuários do sistema.'
			};
		case 'distance':
			return {
				content:
					'Esta camada apresenta as distâncias medidas e salvas no aplicativo. Apenas você e pessoas autorizadas podem ver esses dados.',
				font: 'Usuários do sistema.'
			};
		default:
			return {
				content: '',
				font: 'Usuários do sistema.'
			};
	}
}
